var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4771 47C22.3486 32.961 22.3486 14.0898 44.4771 0L48 1.22078C27.0826 14.5476 27.0826 32.4524 48 45.7792L44.4771 47ZM33.2477 46.8983C16.7339 32.9102 16.7339 14.1407 33.2477 0.152597L37.211 1.11905C21.3578 14.4968 21.3578 32.5033 37.211 45.9318L33.2477 46.8983ZM22.1284 46.7457C11.2294 32.8593 11.2294 14.1916 22.1284 0.254329L26.3119 0.96645C15.7431 14.4459 15.7431 32.5541 26.3119 46.0336L22.1284 46.7457ZM11.0092 46.5931C5.61468 32.8084 5.61468 14.2424 11.0092 0.457792L15.4128 0.813853C10.0183 14.395 10.0183 32.6558 15.4128 46.237L11.0092 46.5931ZM4.40367 46.3896H0V0.61039H4.40367V46.3896Z",
    fill: "#0071BC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorset);
export default __webpack_public_path__ + "static/media/corset.7ef7767e19a3cae157f0c416c6ce0458.svg";
export { ForwardRef as ReactComponent };